<template>
  <b-container fluid v-if="ticket_progression_context_loaded">
    <b-row>
      <b-col v-for="(obj, i) in TicketProgressionObject" :key="'obj-' + i" xl="4" lg="6" md="12">
        <b-container fluid class="pr-2 pb-4 pl-2">
          <card :info="obj.info" :title="obj.title">
            <div slot="image" :class="obj.bg + ' img-box'">
              <img :src="require(`@/assets/${obj.img}`)" alt="img">
            </div>
          </card>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
  <loader-box v-else height="180px" class="mb-4 mr-2 ml-2"/>
</template>

<script>
// ============================ !!!IMPORTANTE !!! =============================
// Os "Diffs" não chegam formatados como os valores normais

import Card from './ComponentCardTicketProgression'
import LoaderBox from '@/components/LoaderBox.vue'

export default {
  components: {
    Card,
    LoaderBox
  },
  computed: {
    ticket_progression_context_loaded() { return this.$store.getters.ticket_progression_context_loaded },
    TicketProgressionObject() { return this.$store.getters.TicketProgressionObject }
  }
}
</script>

<style>

</style>
